<template>
  <div :class="classesInput" class="textarea">
    <label class="label">{{label}}
      <textarea
        :style="[{'color': colorText }, { 'min-height': recievedHeight }]"
        class="input shadown"
        :class="{'textarea-border-none' : borderNone}"
        :value="internalValue"
        :placeholder="placeholder"
        v-bind="$attrs"
        :maxlength="maxlength"
        ref="input"
        v-on="{
          ...$listeners,
          input: event => $emit('input', event.target.value),
          mouseup: event => $emit('highlight', event)
        }"
      ></textarea>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppFormTextarea',
  status: 'prototype',
  release: '1.0.0',
  inheritAttrs: false,
  props: {
    value: {
      required: true
    },
    maxlength: {
      type: String,
      default: '750'
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    background: {
      type: String,
      default: null
    },
    inputHeight: {
      type: String,
      default: '0'
    },
    borderNone: {
      type: Boolean,
      default: false
    },
    colorText: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      lazyValue: this.value,
      recievedHeight: this.inputHeight
    }
  },
  methods: {
    resize () {
      this.recievedHeight = this.$refs.input.scrollHeight + 'px'
    }
  },
  computed: {
    classesInput () {
      return {
        'input-wrapper': true,
        'input--is-label-active': this.isLabelActive,
        'input--is-dirty': this.isDirty,
        'input--is-disabled': this.disabled,
        'input--is-readonly': this.readonly
      }
    },
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    },
    isDirty () {
      return !!this.lazyValue
    },
    isDisabled () {
      return !!this.disabled || !!this.readonly
    },
    isLabelActive () {
      return this.isDirty
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
      this.resize()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.input-wrapper {
  .label {
    font-family: $font-text;
    font-size: $size-m;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    color: $color-purple-darker;
  }
  .input {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    font-family: $font-text;
    font-size: 20px;
    font-weight: 600;
    outline: 0;
    border-radius: 15px;
    border: solid 1px rgb(226, 227, 231);
    background-color: transparent;
    resize: none;
    -webkit-user-select: text;
    -khtml-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
  .input::-webkit-input-placeholder {
    color: $color-gray-light;
  }
  .input::-moz-placeholder {
    color: $color-gray-light;
  }
  .input:-ms-input-placeholder {
    color: $color-gray-light;
  }
  .input:-moz-placeholder {
    color: $color-gray-light;
  }
  .textarea-border-none {
    border: none;
  }
  .textarea {
    textarea {
      padding: 8px;
      border: 1px solid #aeaeae;
      resize: none;
      overflow: hidden;
      font-size: 16px;
      height: 0;

      &.shadow {
        max-height: 0;
        pointer-events: none;
        opacity: 0;
        margin: 0;
      }
    }
  }
}
</style>
